// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';

export const KPIS = {
  valueAtRisk: (
    <Translation
      i18nKey="kpi.valueAtRisk"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  annualizedVolatility: (
    <Translation
      i18nKey="kpi.annualizedVolatility"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  sharpeRatio: (
    <Translation
      i18nKey="kpi.sharpeRatio"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  beta: (
    <Translation
      i18nKey="kpi.beta"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  maxDrawdown: (
    <Translation
      i18nKey="kpi.maxDrawdown"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  avgMarketCap: (
    <Translation
      i18nKey="kpi.avgMarketCap"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  pricePerEarnings: (
    <Translation
      i18nKey="kpi.pricePerEarnings"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  dividendYield: (
    <Translation
      i18nKey="kpi.dividendYield"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  unrealizedGains: (
    <Translation
      i18nKey="kpi.unrealizedGains"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  harvestOpportunity: (
    <Translation
      i18nKey="kpi.harvestOpportunity"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  cashAvailable: (
    <Translation
      i18nKey="kpi.cashAvailable"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  lossesAvailable: (
    <Translation
      i18nKey="kpi.lossesAvailable"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  lossesHarvested: (
    <Translation
      i18nKey="kpi.lossesHarvested"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  realizedGains: (
    <Translation
      i18nKey="kpi.realizedGains"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  rsquare: (
    <Translation
      i18nKey="kpi.rsquare"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
  cagr: (
    <Translation
      i18nKey="kpi.cagr"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  pricePerBook: (
    <Translation
      i18nKey="kpi.pricePerBook"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  alpha: (
    <Translation
      i18nKey="kpi.alpha"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
  realizedSt: (
    <Translation
      i18nKey="kpi.realizedSt"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  realizedLt: (
    <Translation
      i18nKey="kpi.realizedLt"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
  deviation: (
    <Translation
      i18nKey="kpi.deviation"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  totalDebt: (
    <Translation
      i18nKey="kpi.totalDebt"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  longTermDebt: (
    <Translation
      i18nKey="kpi.longTermDebt"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  shortTermDebt: (
    <Translation
      i18nKey="kpi.shortTermDebt"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  availableCredit: (
    <Translation
      i18nKey="kpi.availableCredit"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
};

export type KPIPopupName = keyof typeof KPIS;
